import React from 'react';
import Link from 'next/link';
import Icon from '../Icon';
import { t } from '../../i18n';
import iconType from '../../utils/icontype';
import s from './Map.module.scss';

const Popup = ({
    label = '',
    title = '',
    description = '',
    icon = '',
    url = '',
    showTag,
    tagTextKey = 'map.tagText',
}) => {
    const labelType = label
        ? label.charAt(0).toUpperCase() + label.slice(1)
        : '';

    return (
        <div className={s.Popup}>
            <div className={s.PopupContent}>
                {showTag && (
                    <div className={s.PopupTagWrapper}>
                        <div className={s.PopupTag}>
                            <span className={s.PopupTagText}>
                                {t(tagTextKey)}
                            </span>
                        </div>
                    </div>
                )}
                <div className={s.PopupInfo}>
                    <span className={s.PopupLabel}>{labelType}</span>
                    <h3 className={s.PopupTitle}>{title}</h3>
                    <p className={s.PopupDescription}>{description}</p>
                    <div className={s.PopupIcon}>
                        <Icon name={iconType(icon)} />
                    </div>
                </div>
            </div>
            <Link className={s.PopupButton} href={url}>
                See more company details
            </Link>
        </div>
    );
};

export default Popup;
